export default {
  logo: "logo.png",
  user: "user.png",
  404: "404.svg",
  educhain: "educhain.png",
  cube: "cube.png"
};